import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RequiredDocument } from "../../../@types/requiredDocument";

export const findRequiredDocuments = createAsyncThunk(
  "findRequiredDocument",
  async (id: any, { rejectWithValue }) => {
    try {
      const url = new URL(`${api.baseURL}compliance/get-by-user?userId=${id}`);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data.map((value: RequiredDocument) => ({
        ...value,
        docInfo: [],
        isFromCamera: false,
        isLoaded: false,
        loadingFromInputStatus: "",
        loadingFromCameraInputStatus: "",
        cameraInfo: [],
      }));
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
